import { render, staticRenderFns } from "./BaseItemCompetition.vue?vue&type=template&id=2e1d4a1b&scoped=true&"
import script from "./BaseItemCompetition.vue?vue&type=script&lang=js&"
export * from "./BaseItemCompetition.vue?vue&type=script&lang=js&"
import style0 from "./BaseItemCompetition.vue?vue&type=style&index=0&id=2e1d4a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d4a1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1d4a1b')) {
      api.createRecord('2e1d4a1b', component.options)
    } else {
      api.reload('2e1d4a1b', component.options)
    }
    module.hot.accept("./BaseItemCompetition.vue?vue&type=template&id=2e1d4a1b&scoped=true&", function () {
      api.rerender('2e1d4a1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseItemCompetition.vue"
export default component.exports